module.exports = __webpack_public_path__ + "img/logo.1977efea.svg";